;(function () {
  const PLP_KEY = 'breadcrumb_last_plp'
  const FROM_PLP_KEY = 'breadcrumb_from_plp'

  /** @param {string | null} raw */
  function safeCollectionPathname(raw) {
    if (typeof raw !== 'string' || raw.length === 0) return null
    if (!raw.startsWith('/') || raw.startsWith('//')) return null
    try {
      const u = new URL(raw, window.location.origin)
      if (u.origin !== window.location.origin) return null
      if (!u.pathname.startsWith('/collections/')) return null
      return u.pathname
    } catch {
      return null
    }
  }

  const path = window.location.pathname
  const isCollectionPage = path.startsWith('/collections/')
  const isProductPage = path.includes('/products/')

  // PLP: save current path
  if (isCollectionPage && !isProductPage) {
    sessionStorage.setItem(PLP_KEY, path)
    sessionStorage.setItem(FROM_PLP_KEY, '1')
    return
  }

  // Any non-PLP, non-PDP page
  if (!isProductPage) {
    sessionStorage.removeItem(FROM_PLP_KEY)
    return
  }

  // PDP: enrich breadcrumb from sessionStorage
  const nav = document.querySelector('[data-breadcrumb]')
  if (!nav) return

  const cameFromPlp = sessionStorage.getItem(FROM_PLP_KEY) === '1'
  sessionStorage.removeItem(FROM_PLP_KEY)

  const savedPath = safeCollectionPathname(sessionStorage.getItem(PLP_KEY))
  if (!savedPath) return

  const parts = savedPath.split('/').filter(Boolean)
  if (parts[0] !== 'collections' || !parts[1]) return

  const savedCollectionHandle = parts[1]
  const savedTagSegment = parts[2] || ''
  const savedTag = savedTagSegment
    ? savedTagSegment
        .replace(/^(category|gender|color|size)-/, '')
        .replace(/-/g, ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase())
    : null
  const savedCollectionUrl = `/${parts[0]}/${parts[1]}`
  const savedTagUrl = savedTag ? savedPath : null

  // Verify the saved collection is relevant to this product
  const currentParentUrl = nav.dataset.parentUrl || ''
  const currentCollectionHandle =
    currentParentUrl.split('/collections/')[1]?.split('/')[0] || ''

  if (currentCollectionHandle) {
    // Collection-based URL: session collection must match the URL collection
    if (currentCollectionHandle !== savedCollectionHandle) return
  } else {
    // Direct URL (/products/slug): only use session if user navigated from a PLP
    if (!cameFromPlp) return
  }

  const parentLi = nav.querySelector('[data-breadcrumb-parent]')
  const productLi = nav.querySelector('[aria-current="page"]')?.closest('li')

  if (!productLi) return

  // Build child <li> for the tag sub-category if present
  if (savedTag && savedTagUrl) {
    const childLi = document.createElement('li')
    childLi.className = 'inline'
    childLi.setAttribute('data-breadcrumb-child', '')
    const childA = document.createElement('a')
    childA.setAttribute('href', savedTagUrl)
    childA.textContent = savedTag
    childLi.appendChild(childA)
    productLi.insertAdjacentElement('beforebegin', childLi)
  }

  // If Liquid didn't render a parent (direct URL fallback), inject from session
  if (!parentLi) {
    const collectionTitle = savedCollectionHandle
      .replace(/-/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase())
    const newParentLi = document.createElement('li')
    newParentLi.className = 'inline'
    newParentLi.setAttribute('data-breadcrumb-parent', '')
    const parentA = document.createElement('a')
    parentA.setAttribute('href', savedCollectionUrl)
    parentA.textContent = collectionTitle
    newParentLi.appendChild(parentA)

    // Insert before child (tag) if present, otherwise before product
    const childLi = nav.querySelector('[data-breadcrumb-child]')
    const insertBefore = childLi || productLi
    insertBefore.insertAdjacentElement('beforebegin', newParentLi)
  }
})()
